// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/ehaclinics.eot?72174506", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/ehaclinics.woff2?72174506", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/ehaclinics.woff?72174506", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/ehaclinics.ttf?72174506", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../font/ehaclinics.svg?72174506", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#ehaclinics" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "ehaclinics";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
/*
@media screen and (-webkit-min-device-pixel-ratio:0) {
  @font-face {
    font-family: 'ehaclinics';
    src: url('../font/ehaclinics.svg?72174506#ehaclinics') format('svg');
  }
}
*/
[class^=eha-]:before, [class*=" eha-"]:before {
  font-family: "ehaclinics";
  font-style: normal;
  font-weight: normal;
  speak: never;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  /* opacity: .8; */
  /* For safety - reset parent styles, that can break glyph codes*/
  font-variant: normal;
  text-transform: none;
  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;
  /* Animation center compensation - margins should be symmetric */
  /* remove if not needed */
  margin-left: 0.2em;
  /* you can be more comfortable with increased icons size */
  /* font-size: 120%; */
  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
}

.eha-search:before {
  content: "\\e800";
} /* '' */
.eha-doctor:before {
  content: "\\e801";
} /* '' */
.eha-virus:before {
  content: "\\e802";
} /* '' */
.eha-cart:before {
  content: "\\e803";
} /* '' */
.eha-plus:before {
  content: "\\e804";
} /* '' */
.eha-user:before {
  content: "\\e805";
} /* '' */
.eha-patientfile:before {
  content: "\\e806";
} /* '' */
.eha-close:before {
  content: "\\e807";
} /* '' */
.eha-pregnant:before {
  content: "\\e808";
} /* '' */
.eha-medication:before {
  content: "\\e809";
} /* '' */
.eha-heart:before {
  content: "\\e80a";
} /* '' */
.eha-prescription:before {
  content: "\\e80b";
} /* '' */
.eha-dental:before {
  content: "\\e80c";
} /* '' */
.eha-home:before {
  content: "\\e80d";
} /* '' */
.eha-patient:before {
  content: "\\e80e";
} /* '' */
.eha-ophtalmology:before {
  content: "\\e80f";
} /* '' */
.eha-telemedicine:before {
  content: "\\e810";
} /* '' */
.eha-pharmacy:before {
  content: "\\e811";
} /* '' */
.eha-heartrate:before {
  content: "\\e812";
} /* '' */
.eha-maximize:before {
  content: "\\e813";
} /* '' */
.eha-minimize:before {
  content: "\\e814";
} /* '' */
.eha-dots:before {
  content: "\\e815";
} /* '' */
.eha-immunization:before {
  content: "\\e816";
} /* '' */
.eha-down:before {
  content: "\\e817";
} /* '' */
.eha-left:before {
  content: "\\e818";
} /* '' */
.eha-right:before {
  content: "\\e819";
} /* '' */
.eha-up:before {
  content: "\\e81a";
} /* '' */
.eha-hamburger:before {
  content: "\\e81b";
} /* '' */
.eha-encounter:before {
  content: "\\e81c";
} /* '' */
.eha-height:before {
  content: "\\e81d";
} /* '' */
.eha-weight:before {
  content: "\\e81e";
} /* '' */
.eha-temperature:before {
  content: "\\e81f";
} /* '' */
.eha-level1:before {
  content: "\\e820";
} /* '' */
.eha-level2:before {
  content: "\\e821";
} /* '' */
.eha-level3:before {
  content: "\\e822";
} /* '' */
.eha-level4:before {
  content: "\\e823";
} /* '' */
.eha-checkin:before {
  content: "\\e824";
} /* '' */
.eha-male:before {
  content: "\\e825";
} /* '' */
.eha-neuter:before {
  content: "\\e826";
} /* '' */
.eha-female:before {
  content: "\\e827";
} /* '' */
.eha-telehealth:before {
  content: "\\e828";
} /* '' */
.eha-drop:before {
  content: "\\e829";
} /* '' */
.eha-appointment:before {
  content: "\\e82a";
} /* '' */
.eha-lungs:before {
  content: "\\e82b";
} /* '' */
.eha-clock-1:before {
  content: "\\e82c";
} /* '' */
.eha-lab:before {
  content: "\\e82d";
} /* '' */
.eha-arm:before {
  content: "\\e830";
} /* '' */
.eha-abdomen:before {
  content: "\\e831";
} /* '' */
.eha-head:before {
  content: "\\e832";
} /* '' */
.eha-phone:before {
  content: "\\e833";
} /* '' */
.eha-email:before {
  content: "\\e834";
} /* '' */
.eha-settings:before {
  content: "\\e835";
} /* '' */
.eha-check-circle:before {
  content: "\\e836";
} /* '' */
.eha-circle:before {
  content: "\\e837";
} /* '' */
.eha-fullscreen-enter:before {
  content: "\\e838";
} /* '' */
.eha-fullscreen-exit:before {
  content: "\\e839";
} /* '' */
.eha-clock:before {
  content: "\\e83a";
} /* '' */
.eha-calendar-empty:before {
  content: "\\f133";
} /* '' */
.eha-hourglass-1:before {
  content: "\\f251";
} /* '' */`, "",{"version":3,"sources":["webpack://./src/fontello/css/ehaclinics.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,yBAAA;EACA,4CAAA;EACA,4SAAA;EAKA,mBAAA;EACA,kBAAA;AAFF;AAIA,gGAAA;AACA,2FAAA;AACA;;;;;;;CAAA;AAQA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EAEA,qBAAA;EACA,wBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,gEAAA;EACA,oBAAA;EACA,oBAAA;EAEA,8CAAA;EACA,gBAAA;EAEA,gEAAA;EACA,yBAAA;EACA,kBAAA;EAEA,0DAAA;EACA,qBAAA;EAEA,6CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,uDAAA;AATF;;AAYA;EAAqB,gBAAA;AARrB,EAQyC,QAAA;AACzC;EAAqB,gBAAA;AANrB,EAMyC,QAAA;AACzC;EAAoB,gBAAA;AAJpB,EAIwC,QAAA;AACxC;EAAmB,gBAAA;AAFnB,EAEuC,QAAA;AACvC;EAAmB,gBAAA;AAAnB,EAAuC,QAAA;AACvC;EAAmB,gBAAA;AAEnB,EAFuC,QAAA;AACvC;EAA0B,gBAAA;AAI1B,EAJ8C,QAAA;AAC9C;EAAoB,gBAAA;AAMpB,EANwC,QAAA;AACxC;EAAuB,gBAAA;AAQvB,EAR2C,QAAA;AAC3C;EAAyB,gBAAA;AAUzB,EAV6C,QAAA;AAC7C;EAAoB,gBAAA;AAYpB,EAZwC,QAAA;AACxC;EAA2B,gBAAA;AAc3B,EAd+C,QAAA;AAC/C;EAAqB,gBAAA;AAgBrB,EAhByC,QAAA;AACzC;EAAmB,gBAAA;AAkBnB,EAlBuC,QAAA;AACvC;EAAsB,gBAAA;AAoBtB,EApB0C,QAAA;AAC1C;EAA2B,gBAAA;AAsB3B,EAtB+C,QAAA;AAC/C;EAA2B,gBAAA;AAwB3B,EAxB+C,QAAA;AAC/C;EAAuB,gBAAA;AA0BvB,EA1B2C,QAAA;AAC3C;EAAwB,gBAAA;AA4BxB,EA5B4C,QAAA;AAC5C;EAAuB,gBAAA;AA8BvB,EA9B2C,QAAA;AAC3C;EAAuB,gBAAA;AAgCvB,EAhC2C,QAAA;AAC3C;EAAmB,gBAAA;AAkCnB,EAlCuC,QAAA;AACvC;EAA2B,gBAAA;AAoC3B,EApC+C,QAAA;AAC/C;EAAmB,gBAAA;AAsCnB,EAtCuC,QAAA;AACvC;EAAmB,gBAAA;AAwCnB,EAxCuC,QAAA;AACvC;EAAoB,gBAAA;AA0CpB,EA1CwC,QAAA;AACxC;EAAiB,gBAAA;AA4CjB,EA5CqC,QAAA;AACrC;EAAwB,gBAAA;AA8CxB,EA9C4C,QAAA;AAC5C;EAAwB,gBAAA;AAgDxB,EAhD4C,QAAA;AAC5C;EAAqB,gBAAA;AAkDrB,EAlDyC,QAAA;AACzC;EAAqB,gBAAA;AAoDrB,EApDyC,QAAA;AACzC;EAA0B,gBAAA;AAsD1B,EAtD8C,QAAA;AAC9C;EAAqB,gBAAA;AAwDrB,EAxDyC,QAAA;AACzC;EAAqB,gBAAA;AA0DrB,EA1DyC,QAAA;AACzC;EAAqB,gBAAA;AA4DrB,EA5DyC,QAAA;AACzC;EAAqB,gBAAA;AA8DrB,EA9DyC,QAAA;AACzC;EAAsB,gBAAA;AAgEtB,EAhE0C,QAAA;AAC1C;EAAmB,gBAAA;AAkEnB,EAlEuC,QAAA;AACvC;EAAqB,gBAAA;AAoErB,EApEyC,QAAA;AACzC;EAAqB,gBAAA;AAsErB,EAtEyC,QAAA;AACzC;EAAyB,gBAAA;AAwEzB,EAxE6C,QAAA;AAC7C;EAAmB,gBAAA;AA0EnB,EA1EuC,QAAA;AACvC;EAA0B,gBAAA;AA4E1B,EA5E8C,QAAA;AAC9C;EAAoB,gBAAA;AA8EpB,EA9EwC,QAAA;AACxC;EAAsB,gBAAA;AAgFtB,EAhF0C,QAAA;AAC1C;EAAkB,gBAAA;AAkFlB,EAlFsC,QAAA;AACtC;EAAkB,gBAAA;AAoFlB,EApFsC,QAAA;AACtC;EAAsB,gBAAA;AAsFtB,EAtF0C,QAAA;AAC1C;EAAmB,gBAAA;AAwFnB,EAxFuC,QAAA;AACvC;EAAoB,gBAAA;AA0FpB,EA1FwC,QAAA;AACxC;EAAoB,gBAAA;AA4FpB,EA5FwC,QAAA;AACxC;EAAuB,gBAAA;AA8FvB,EA9F2C,QAAA;AAC3C;EAA2B,gBAAA;AAgG3B,EAhG+C,QAAA;AAC/C;EAAqB,gBAAA;AAkGrB,EAlGyC,QAAA;AACzC;EAA+B,gBAAA;AAoG/B,EApGmD,QAAA;AACnD;EAA8B,gBAAA;AAsG9B,EAtGkD,QAAA;AAClD;EAAoB,gBAAA;AAwGpB,EAxGwC,QAAA;AACxC;EAA6B,gBAAA;AA0G7B,EA1GiD,QAAA;AACjD;EAA0B,gBAAA;AA4G1B,EA5G8C,QAAA","sourcesContent":["@font-face {\n  font-family: 'ehaclinics';\n  src: url('../font/ehaclinics.eot?72174506');\n  src: url('../font/ehaclinics.eot?72174506#iefix') format('embedded-opentype'),\n       url('../font/ehaclinics.woff2?72174506') format('woff2'),\n       url('../font/ehaclinics.woff?72174506') format('woff'),\n       url('../font/ehaclinics.ttf?72174506') format('truetype'),\n       url('../font/ehaclinics.svg?72174506#ehaclinics') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\n/*\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  @font-face {\n    font-family: 'ehaclinics';\n    src: url('../font/ehaclinics.svg?72174506#ehaclinics') format('svg');\n  }\n}\n*/\n[class^=\"eha-\"]:before, [class*=\" eha-\"]:before {\n  font-family: \"ehaclinics\";\n  font-style: normal;\n  font-weight: normal;\n  speak: never;\n\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  margin-right: .2em;\n  text-align: center;\n  /* opacity: .8; */\n\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  margin-left: .2em;\n\n  /* you can be more comfortable with increased icons size */\n  /* font-size: 120%; */\n\n  /* Font smoothing. That was taken from TWBS */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n\n.eha-search:before { content: '\\e800'; } /* '' */\n.eha-doctor:before { content: '\\e801'; } /* '' */\n.eha-virus:before { content: '\\e802'; } /* '' */\n.eha-cart:before { content: '\\e803'; } /* '' */\n.eha-plus:before { content: '\\e804'; } /* '' */\n.eha-user:before { content: '\\e805'; } /* '' */\n.eha-patientfile:before { content: '\\e806'; } /* '' */\n.eha-close:before { content: '\\e807'; } /* '' */\n.eha-pregnant:before { content: '\\e808'; } /* '' */\n.eha-medication:before { content: '\\e809'; } /* '' */\n.eha-heart:before { content: '\\e80a'; } /* '' */\n.eha-prescription:before { content: '\\e80b'; } /* '' */\n.eha-dental:before { content: '\\e80c'; } /* '' */\n.eha-home:before { content: '\\e80d'; } /* '' */\n.eha-patient:before { content: '\\e80e'; } /* '' */\n.eha-ophtalmology:before { content: '\\e80f'; } /* '' */\n.eha-telemedicine:before { content: '\\e810'; } /* '' */\n.eha-pharmacy:before { content: '\\e811'; } /* '' */\n.eha-heartrate:before { content: '\\e812'; } /* '' */\n.eha-maximize:before { content: '\\e813'; } /* '' */\n.eha-minimize:before { content: '\\e814'; } /* '' */\n.eha-dots:before { content: '\\e815'; } /* '' */\n.eha-immunization:before { content: '\\e816'; } /* '' */\n.eha-down:before { content: '\\e817'; } /* '' */\n.eha-left:before { content: '\\e818'; } /* '' */\n.eha-right:before { content: '\\e819'; } /* '' */\n.eha-up:before { content: '\\e81a'; } /* '' */\n.eha-hamburger:before { content: '\\e81b'; } /* '' */\n.eha-encounter:before { content: '\\e81c'; } /* '' */\n.eha-height:before { content: '\\e81d'; } /* '' */\n.eha-weight:before { content: '\\e81e'; } /* '' */\n.eha-temperature:before { content: '\\e81f'; } /* '' */\n.eha-level1:before { content: '\\e820'; } /* '' */\n.eha-level2:before { content: '\\e821'; } /* '' */\n.eha-level3:before { content: '\\e822'; } /* '' */\n.eha-level4:before { content: '\\e823'; } /* '' */\n.eha-checkin:before { content: '\\e824'; } /* '' */\n.eha-male:before { content: '\\e825'; } /* '' */\n.eha-neuter:before { content: '\\e826'; } /* '' */\n.eha-female:before { content: '\\e827'; } /* '' */\n.eha-telehealth:before { content: '\\e828'; } /* '' */\n.eha-drop:before { content: '\\e829'; } /* '' */\n.eha-appointment:before { content: '\\e82a'; } /* '' */\n.eha-lungs:before { content: '\\e82b'; } /* '' */\n.eha-clock-1:before { content: '\\e82c'; } /* '' */\n.eha-lab:before { content: '\\e82d'; } /* '' */\n.eha-arm:before { content: '\\e830'; } /* '' */\n.eha-abdomen:before { content: '\\e831'; } /* '' */\n.eha-head:before { content: '\\e832'; } /* '' */\n.eha-phone:before { content: '\\e833'; } /* '' */\n.eha-email:before { content: '\\e834'; } /* '' */\n.eha-settings:before { content: '\\e835'; } /* '' */\n.eha-check-circle:before { content: '\\e836'; } /* '' */\n.eha-circle:before { content: '\\e837'; } /* '' */\n.eha-fullscreen-enter:before { content: '\\e838'; } /* '' */\n.eha-fullscreen-exit:before { content: '\\e839'; } /* '' */\n.eha-clock:before { content: '\\e83a'; } /* '' */\n.eha-calendar-empty:before { content: '\\f133'; } /* '' */\n.eha-hourglass-1:before { content: '\\f251'; } /* '' */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
